import { useEffect } from "react";
import { useImmer } from "use-immer";

import { useIsIntelligems } from "@src/api/user-auths/is-intelligems";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useAdminHasFullAccess } from "@src/api/user-auths/use-admin-has-full-access";

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useImmer<boolean | undefined>(undefined);
  const isIntelligems = useIsIntelligems();
  const adminHasFullAccess = useAdminHasFullAccess();
  const user = useLoggedInUser();

  useEffect(() => {
    if (isIntelligems) {
      if (user.data?.user?.email === "member@intelligems.io") {
        setIsAdmin(false);
      } else if (!adminHasFullAccess) {
        setIsAdmin(false);
      } else {
        setIsAdmin(true);
      }
    } else {
      setIsAdmin(false);
    }
  }, [isIntelligems, adminHasFullAccess]);

  return isAdmin;
};
